import Utils from "@teamprevent/common/utils";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import axios from "axios";

import { PartiallyMatchedEmployeeListModel } from "..";

const apiUrl = "/api/partiallyMatchedEmployee";

const getAll = async (): Promise<PartiallyMatchedEmployeeListModel[]> => {
    const response = await axios.get<ServerModelWithDateStrings<PartiallyMatchedEmployeeListModel>[]>(`${apiUrl}${Utils.getOnlyParameters()}`);
    const data = response.data;
    return data;
};

export const PartiallyMatchedEmployeeApi = { getAll };
